import React from "react";
import { PAGE_MODE } from "../../../../../constants/constants";
import BarButtonFw, { BUTTON_DEFAULT, } from "../../../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../../../framework/form/FormFw";
import { MessageUtil } from '../../../../../util/MessageUtil';
import { LoadUtil } from "../../../../../framework/util/LoadUtil";
import { EnvConstants } from "../../../../../EnvConstants";
import { UserUtil } from "../../../../../util/UserUtil";
import { LoadingUtil } from '../../../../../util/LoadingUtil';
import { BasePage } from "../../../../../framework/pages/BasePage";
import { AgregarGrupoDestinatarioModal } from "../modals/AgregarGrupoDestinatarioModal";
import { AgregarGrupoFacturaModal } from "../modals/AgregarGrupoFacturaModal";
import { AgregarTitularFacturaModal } from "../modals/AgregarTitularFacturaModal";

class DatosEmisionInformeFacturaSection extends BasePage {
    state = {
        formGrupo: {},
        pageApi: null
    }

    componentWillUnmount() {
        const pageApi = this.state.pageApi;
        if (pageApi && pageApi.getComponent) {
            const form = pageApi.getComponent('form');
            if (form && typeof form.getData === 'function') {
                const data = form.getData();
                sessionStorage.setItem("datos_emision_informe_factura", JSON.stringify(data));
            }
        } else {
            console.warn("No se encontró pageApi o el componente form.");
        }
    }

    renderPage(pageApi) {
        const getForm_dat_emision_InfFac = () => pageApi.getComponent('form');
        const getForm_datos_solicitante = () => pageApi.getComponent('form_datosSolicitantes');
        const dataJson = sessionStorage.getItem("datos_emision_informe_factura") || '{}'
        this.formGrupo = JSON.parse(dataJson);
        this.state.pageApi = pageApi;

        const fnLoadForm = () => {
            const dataJson = JSON.stringify(getForm_dat_emision_InfFac().getData());
            sessionStorage.setItem("datos_emision_informe_factura", dataJson)
            window.location.reload();
        }

        const ConfigGrupoDestiModal = (data) => {
            let obj = {};
            obj = {
                fnLoadForm,
                data: {
                    ...data,
                    id_empresa: getForm_datos_solicitante().getData().id_empresa,
                    id_pers_contac: getForm_datos_solicitante().getData().id_solicitante
                },
            };
            return {
                width: 500,
                maskClosable: true,
                closable: false,
                background: 'white',
                component: <AgregarGrupoDestinatarioModal name={obj} getParentApi={pageApi.getApi} />
            }
        };

        const ConfigGrupoFacturaModal = (data) => {
            let obj = {};

            obj = {
                fnLoadForm,
                data: {
                    ...data,
                    id_empresa: getForm_datos_solicitante().getData().id_empresa,
                    id_pers_contac: getForm_datos_solicitante().getData().id_solicitante
                },
            };
            return {
                width: 500,
                maskClosable: true,
                closable: false,
                background: 'white',
                component: <AgregarGrupoFacturaModal name={obj} getParentApi={pageApi.getApi} />
            }
        };

        const ConfigTitularFacturaModal = (data) => {
            let obj = {};

            obj = {
                fnLoadForm,
                data: {
                    ...data,
                    id_empresa: getForm_datos_solicitante().getData().id_empresa,
                    id_pers_contac: getForm_datos_solicitante().getData().id_solicitante
                },
            };
            return {
                width: 500,
                maskClosable: true,
                closable: false,
                background: 'white',
                component: <AgregarTitularFacturaModal name={obj} getParentApi={pageApi.getApi} />
            }
        };

        const form_datosSolicitantes = {
            layout: 'vertical',
            load: {
                queryId: 815,
                search: true,
                hideMessage: true,
                hideMessageError: true,
                params: { id_doc: pageApi.getParamId() }
            },
            title: '',
            fields: [
                {
                    label: '  ',
                    fields: [
                        { type: 'hidden', name: 'id_doc' },
                        { name: "raz_soc", label: "Empresa", column: 4, readOnly: true },
                        { name: "solicitante", label: "Solicitante", column: 4, readOnly: true },
                        { name: "servicio", label: "Tipo Servicio", column: 4, readOnly: true },
                    ]
                }
            ],
            onComponentLoad: (formApi, pageApi) => {
                if (pageApi.getPageMode() !== PAGE_MODE.NEW)
                    formApi.load();
            }
        }

        const form_dat_emision_InfFac = {
            layout: 'vertical',
            autoload: true,
            load: {
                validation: () => pageApi.getParamId() != null, //solo se dispara si el valor es distinto de nulo
                queryId: 238,
                params: { id_doc: pageApi.getParamId() },
                hideMessage: true,
                hideMessageError: true
            },
            save: {
                queryId: 239,
                params: { est_tab: 5, id_doc: pageApi.getParamId(), id_user: UserUtil.getUserId() },
                fnOk: () => {
                    LoadingUtil.loadShow();

                    const promise1 = new Promise((resolve, reject) => {
                        LoadUtil.loadByQueryId({
                            url: EnvConstants.GET_FW_URL_SEND_MAIL() + '/Cliente_correoSS',
                            queryId: 833,
                            reqParams: {
                            params: { id_doc: pageApi.getParamId() }
                            },
                            fnOk: (resp) => {
                            MessageUtil(
                                'success',
                                `N°: ${getForm_datos_solicitante().getData().nro_ss}`,
                                'El área comercial revisará su solicitud y procederá con la conformidad. ' + resp.message + '.'
                            );
                            resolve(resp);
                            },
                            fnError: (err) => reject(err)
                        });
                    });

                    const promise2 = new Promise((resolve, reject) => {
                        LoadUtil.loadByQueryId({
                            url: EnvConstants.GET_FW_URL_SEND_MAIL() + '/Cliente_correoSS_Laboratorio',
                            queryId: 868,
                            reqParams: {
                            params: { id_doc: pageApi.getParamId() }
                            },
                            fnOk: (resp) => resolve(resp),
                            fnError: (err) => reject(err)
                        });
                    });

                    Promise.all([promise1, promise2])
                    .then(([resp1, resp2]) => {
                        getForm_dat_emision_InfFac().load();
                        getForm_dat_emision_InfFac().history.push("/servicios-ejecutados/servicios-ejecutados-admin");
                    })
                    .catch((err) => {
                        console.error("Error al enviar correo:", err);
                        MessageUtil('error', 'Error', 'Ocurrió un problema al enviar los correos.');
                    })
                    .finally(() => {
                        LoadingUtil.loadHide();
                    });
                },
                hideMessage: true,
                hideMessageError: true
            },
            title: '',
            //collapsible: true,
            fields: [
                {
                    label: '  ',
                    fields: [
                        { type: 'hidden', name: 'id_empresa' },
                        {
                            type: 'select', name: 'id_titular_informe', label: 'Títular de Informe', column: 4, search: true, load: {
                                queryId: 865, fnOk: () => {
                                    const form = getForm_dat_emision_InfFac().getData();
                                    getForm_dat_emision_InfFac().setData({ ...this.formGrupo })
                                },
                            },
                            parents: [{ name: 'id_empresa', paramName: 'id_empresa', required: true }], onChange: (value, values, formApi) => {
                                if (value == 0) {
                                    pageApi.showModal(ConfigTitularFacturaModal(formApi.getData()))
                                    formApi.setFieldData('id_titular_informe', null);
                                } else {
                                    formApi.setFieldData('id_titular_informe', value);
                                }
                            },
                        },
                        {
                            type: 'select', name: 'id_grupo_destinatario', label: 'Grupo Destinario', column: 4, load: {
                                queryId: 848, fnOk: () => {
                                    getForm_dat_emision_InfFac().setData({ ...this.formGrupo })
                                }
                            }, allowClear: true,
                            parents: [{ name: 'id_empresa', paramName: 'id_empresa', required: true }], onChange: (value, values, formApi) => {
                                if (value == 0) {
                                    pageApi.showModal(ConfigGrupoDestiModal(formApi.getData()))
                                    formApi.setFieldData('id_grupo_destinatario', null);
                                } else {
                                    formApi.setFieldData('id_grupo_destinatario', value);
                                }
                            }
                        },
                        {
                            type: 'select', name: 'id_prioridad', label: 'Prioridad', column: 4, load: {
                                queryId: 228, fnOk: () => {
                                    getForm_dat_emision_InfFac().setData({ ...this.formGrupo })
                                },
                            },
                        },
                        {
                            type: 'select', name: 'id_titular_factura', label: 'Titular de Factura', column: 4, search: true, load: {
                                queryId: 215, fnOk: () => {
                                    getForm_dat_emision_InfFac().setData({ ...this.formGrupo })
                                },
                            },
                            parents: [{ name: 'id_empresa', paramName: 'id_empresa', required: true }]
                        },
                        {
                            type: 'select', name: 'id_grupo_facturacion', label: 'Grupos Facturación', column: 4, load: {
                                queryId: 849, fnOk: () => {
                                    getForm_dat_emision_InfFac().setData({ ...this.formGrupo })

                                }
                            }, allowClear: true,
                            parents: [{ name: 'id_empresa', paramName: 'id_empresa', required: true }], onChange: (value, values, formApi) => {
                                if (value == 0) {
                                    pageApi.showModal(ConfigGrupoFacturaModal(formApi.getData()))
                                    formApi.setFieldData('id_grupo_facturacion', null);
                                } else {
                                    formApi.setFieldData('id_grupo_facturacion', value);
                                }
                            }
                        },
                        { type: 'number', name: 'tiempo_entrega', label: 'Tiempo de Entrega (Dias)', column: 4, readOnly: true, },
                        {type: 'select', name:'emision_informe', label:'Tipo Informe', column: 4, 
                            load: {
                                dataList: [
                                    {label: 'Informe por Cadena', value: 18},
                                    {label: 'Informe por Estación', value: 22},
                                    {label: 'otros', value: 12}, 
                                ]
                            }, 
                        }, 
                    ]
                }
            ],
            onComponentLoad: (formApi, pageApi) => {
                if (pageApi.getPageMode() !== PAGE_MODE.NEW)
                    formApi.load();
            }
        }

        const barButtonFooter_dat_emision_InfFac = {
            fields: [
                { ...BUTTON_DEFAULT.RETURN, link: () => {
                    sessionStorage.removeItem("datos_emision_informe_factura");
                    return '/servicios-ejecutados/servicios-ejecutados-admin';
                }, alert: true, message: 'Está seguro de retornar?', },
                { ...BUTTON_DEFAULT.SAVE, label: "Guardar y Continuar", onClick: () => { getForm_dat_emision_InfFac().save() } },
            ]
        }

        return (
            <>
                <FormFw
                    name="form_datosSolicitantes"
                    getParentApi={pageApi.getApi}
                    config={form_datosSolicitantes}
                />

                <FormFw
                    name="form"
                    getParentApi={pageApi.getApi}
                    config={form_dat_emision_InfFac}
                />

                <BarButtonFw
                    name="barFooter"
                    getParentApi={pageApi.getApi}
                    config={barButtonFooter_dat_emision_InfFac}
                />
            </>
        );
    }
}
export default DatosEmisionInformeFacturaSection